import React from 'react';
import { pxToRem } from '../util';
import Segment from './Segment';
import DiseaseScrollList from './DiseaseScrollList';
import CardHeader from './CardHeader';
const Box1 = (props: { charts: any }) => {
  const color = 'rgb(206, 234, 255)';
  const [index, setIndex] = React.useState(0);
  const values = ['已确诊', '明显风险', '一定风险', '暂无风险', '缺乏数据'];
  const [list, setList] = React.useState([]);
  React.useEffect(() => {
    const tmpList = [];
    tmpList[0] = [];
    tmpList[1] = [];
    tmpList[2] = [];
    tmpList[3] = [];
    tmpList[4] = [];
    (props.charts?.diseaseCondition || []).forEach((item: any) => {
      [
        'diagnosedTotal',
        'obviousRiskTotal',
        'certainRiskTotal',
        'noRiskTotal',
        'lackDataTotal',
      ].forEach((key, i) => {
        if (item[key] > 0) {
          tmpList[i].push({
            name: item.diseaseName,
            total: props.charts?.totalCharts?.archivesTotal || 0,
            value: item[key],
          });
        }
      });
    });
    // 将每个子数组按照value排序
    tmpList.forEach((subList) => {
      subList.sort((a, b) => b.value - a.value);
    });
    console.warn('tmpList', tmpList);
    setList(tmpList);
  }, [props.charts]);
  return (
    <div
      style={{
        background:
          'linear-gradient(0deg, rgb(21, 35, 48) 2%, rgb(17, 26, 40) 100%)',
        height: '35vh',
        padding: '5px',
        boxSizing: 'border-box',
        fontFamily: '阿里妈妈数黑体 Bold',
      }}
    >
      {/* <div
        style={{
          color: 'white',
          display: 'flex',
          flexDirection: 'column',
          fontSize: pxToRem(18),
        }}
      >
        <span>确诊疾病情况</span>
        <span
          style={{
            fontSize: pxToRem(12),
            display: 'inline-block',
            padding: '1px 4px',
            color,
            width: 'fit-content',
            borderRadius: '2px',
            backgroundColor: 'rgba(255, 255, 255, 0.12)',
          }}
        >
          Confirmed disease status
        </span>
      </div> */}
      <CardHeader title="疾病分布情况" subtitle="Confirmed disease status" />
      <div style={{ height: '28vh', marginTop: pxToRem(5) }}>
        <Segment
          items={values}
          height={25}
          initialIndex={index}
          onChange={(i) => setIndex(i)}
        />
        <div style={{ height: pxToRem(5) }} />
        {/* 假如index变动，重置组件 */}
        <DiseaseScrollList
          data={list[index]}
          key={index}
          height={'26vh'}
          rowHeight={30}
          visibleRows={7}
          scrollInterval={3000}
        />
      </div>
    </div>
  );
};
export default Box1;
